module.exports = __webpack_public_path__ + "static/img/03st.cdec7e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/06/03st.jpg
// module id = uwmh
// module chunks = 0